import { createSlice } from "@reduxjs/toolkit";
import {
  addPersonalHistory,
  fetchPersonalHistoryByUserId,
  updatePersonalHistory,
} from "../thunks/personalHistoryThunks";

const initialState = {
  items: [],       
  loading: false,
  error: null,
  hasFetched: false,
};

const personalHistorySlice = createSlice({
  name: "personalHistory",
  initialState,
  reducers: {
    clearPersonalHistoryError: (state) => { state.error = null; },
    resetPersonalHistory: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchPersonalHistoryByUserId.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchPersonalHistoryByUserId.fulfilled, (state, action) => {
          state.loading = false;
          state.items = action.payload;
          state.hasFetched = true;
        })
        .addCase(fetchPersonalHistoryByUserId.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.hasFetched = true;
        })

        .addCase(updatePersonalHistory.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updatePersonalHistory.fulfilled, (state) => {
          state.loading = false;
          // on ne modifie pas items ici : tu peux refetch si nécessaire
        })
        .addCase(updatePersonalHistory.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(addPersonalHistory.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(addPersonalHistory.fulfilled, (state) => {
          state.loading = false;
          // on ne modifie pas items ici : tu peux refetch si nécessaire
        })
        .addCase(addPersonalHistory.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
  },
});

export const { clearPersonalHistoryError, resetPersonalHistory } = personalHistorySlice.actions;
export default personalHistorySlice.reducer;